import React, { useCallback, useEffect, useRef, useState } from 'react'

const MENU_HEIGHT = 300;
// Le menu s'ouvre une ligne sous le haut du curseur, sous le texte saisi.
const LINE_OFFSET = 16;

const MenuWrapper = ({ startOffset, children, hide }) => {
  const ref = useRef(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });

  const updateMenuPosition = useCallback(() => {
    const selection = window.getSelection && window.getSelection();
    if (selection && selection.rangeCount > 0) {
      let selectionRange = selection.getRangeAt(0);
      if (selectionRange) {
        const { left: leftPosition, top: caretTop } = selectionRange.getBoundingClientRect();
        const left = ref.current?.offsetWidth && leftPosition + ref.current.offsetWidth >= window.innerWidth ?
          window.innerWidth - ref.current.offsetWidth : leftPosition
        // Sans la place en dessous (texte en bas d'écran, pied de page), le
        // menu s'ouvre au-dessus du curseur : fixé à l'écran, il y serait coupé.
        const fitsBelow = caretTop + LINE_OFFSET + MENU_HEIGHT <= window.innerHeight
        const top = fitsBelow ? caretTop + LINE_OFFSET : Math.max(0, caretTop - MENU_HEIGHT)
        setMenuPosition({ left, top })
      }
    }
  }, []);

  useEffect(() => {
    updateMenuPosition()
  }, [updateMenuPosition, startOffset])

  return (
    <ol
      ref={ref}
      className='no-scrollbar'
      style={{
        // Fixe : la position vient de getBoundingClientRect, relative à
        // l'écran. En absolu, le menu (monté, caché, dès qu'un texte est
        // sélectionné) prolongeait la page de ses 300px sous le curseur : la
        // page devenait défilable et, défilée, chaque frappe le replaçait
        // ailleurs, changeant la hauteur de la page et faisant sauter la vue
        // (édition d'en-tête / pied de page).
        position: "fixed",
        ...menuPosition,
        zIndex: 9998,
        backgroundColor: "#fff",
        // eslint-disable-next-line no-multi-str
        boxShadow: "0 1px 1px hsl(0deg 0% 0% / 0.075),\
      0 2px 2px hsl(0deg 0% 0% / 0.075),\
      0 4px 4px hsl(0deg 0% 0% / 0.075),\
      0 8px 8px hsl(0deg 0% 0% / 0.075),\
      0 16px 16px hsl(0deg 0% 0% / 0.075)",
        display: "flex",
        flexDirection: "column",
        padding: 0,
        borderRadius: 8,
        height: MENU_HEIGHT,
        minWidth: 350,
        overflowY: "scroll",
        listStyleType: "none",
        visibility: hide ? 'hidden' : 'visible'
      }}
    >
      {children}
    </ol>
  )
}

export default MenuWrapper;
